import {
  ActionIcon,
  Badge,
  Group,
  Indicator,
  Text,
  Tooltip
} from '@mantine/core'
import { Info } from 'lucide-react'
import React from 'react'


export interface TooltipInfoProps {
  tooltip?: string | React.ReactNode
}

export interface DirtyFieldLabelProps extends TooltipInfoProps{
  label: string
  changed?: boolean
}

export const TooltipInfo = ({tooltip}: TooltipInfoProps) => {
  return (
    <Tooltip label={tooltip}>
    <ActionIcon
      variant='transparent'
      color='blue'
      size="xs"
    >
      <Info size={10} />
    </ActionIcon>
    </Tooltip>
  )
}

export const DirtyFieldLabel = ({ label, tooltip, changed = false }: DirtyFieldLabelProps) => {
  return (
    <Group gap={6}>
      {changed && (
        <Indicator color="orange" size={8} processing />
      )}
      <Group gap={1}>
        <Text fw={600}>
          {label}
        </Text>
        {tooltip ? (
          <TooltipInfo
            tooltip={tooltip}
          />
        ) : null}
      </Group>
      {changed && (
        <Badge size="xs" color="orange" variant="light">
          changed
        </Badge>
      )}
    </Group>
  )
}